import React from 'react';
import { Button } from 'antd';

import "./style.css";


export default class DynamicButton extends React.Component {

	// componentWillReceiveProps(nextProps) {
	// 	console.log(nextProps)
	// }

	buttonColumn = []

	componentWillMount() {
		if (!this.props.access || !this.props.access[this.props.module]) {
			this.buttonColumn = this.props.column;
		}else{
			this.props.column.forEach(columnItem => {
				if (!columnItem.access || this.props.access[this.props.module][columnItem.access]) {
					this.buttonColumn.push(columnItem);
				}
			})
		}
	}

	render () {
		return (
			<div>
				{this.buttonColumn.map((column, index) => column.link ?
					<div key={index} className="colAction"
						style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button icon={column.icon}
							type={column.type ? column.type : "primary"}
							size={column.size ? column.size : "default"}
							disabled={column.disabled}
							onClick={column.click} >
							<span>{column.title}</span>
						</Button>
					</div> :					
					<div key={index} className="colAction"
						style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button icon={column.icon}
							type={column.type ? column.type : "primary"}
							size={column.size ? column.size : "default"}
							disabled={column.disabled}
							onClick={column.click} >
							<span>{column.title}</span>
						</Button>
					</div>
				)}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/frame/DynamicButton.js